var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOxfordCsPos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 3280.6934,
    height: 1574.9867,
    viewBox: "0 0 3280.6934 1574.9867",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-283.036,-219.05158)",
    id: "path5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-738.59392,-219.05158)",
    id: "path7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-852.67232,-195.4031)",
    id: "path9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-574.36822,-241.57858)",
    id: "path11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-978.59282,-283.41531)",
    id: "path13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-362.39801,-153.15913)",
    id: "path15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-212.86621,-357.01543)",
    id: "path17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-284.4016,-351.73363)",
    id: "path19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-379.31591,-351.74158)",
    id: "path23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-421.29521,-351.74158)",
    id: "path25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-517.22722,-351.74158)",
    id: "path27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-658.61962,-412.34159)",
    id: "path31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-717.31582,-378.34431)",
    id: "path33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-814.22762,-350.46583)",
    id: "path35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-875.08465,-412.34159)",
    id: "path37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-541.97752,-402.63239)",
    id: "path39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-851.22715,-874.50242)",
    id: "path41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-857.81545,-874.50242)",
    id: "path43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-939.8035,-889.41382)",
    id: "path45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-805.0633,-922.96642)",
    id: "path47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-843.00242,-955.97642)",
    id: "path49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-854.48102,-723.66562)",
    id: "path51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-892.4128,-756.67682)",
    id: "path53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-903.77245,-922.96642)",
    id: "path55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-941.70835,-955.97642)",
    id: "path57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-790.55979,-871.04682)",
    id: "path59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-805.24555,-875.05542)",
    id: "path61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-833.9539,-881.35152)",
    id: "path63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-840.76292,-871.06772)",
    id: "path65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-806.9755,-842.38742)",
    id: "path67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-815.47172,-842.38742)",
    id: "path69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-824.9356,-846.85682)",
    id: "path71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-797.64542,-820.71592)",
    id: "path73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-805.95625,-820.44392)",
    id: "path75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-817.66382,-820.44392)",
    id: "path77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-827.68892,-817.21222)",
    id: "path79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-884.04362,-881.35152)",
    id: "path81"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-890.85775,-871.06772)",
    id: "path83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-906.4675,-867.56302)",
    id: "path85"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath87"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-912.57325,-873.08282)",
    id: "path87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-883.873,-845.89262)",
    id: "path89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-894.86162,-845.89262)",
    id: "path91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-902.13025,-849.88122)",
    id: "path93"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-890.07062,-830.99662)",
    id: "path95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-893.31302,-827.64122)",
    id: "path97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-907.64755,-822.73102)",
    id: "path99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-835.55822,-648.56592)",
    id: "path101"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-891.20065,-639.43771)",
    id: "path103"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath105"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-859.75135,-1035.975)",
    id: "path105"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-990.32755,-984.61382)",
    id: "path107"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-715.14432,-749.08382)",
    id: "path109"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-651.82541,-787.76892)",
    id: "path111"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-646.18912,-817.78022)",
    id: "path113"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-645.01972,-865.35112)",
    id: "path115"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath117"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-673.92992,-942.50353)",
    id: "path117"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-724.67872,-1010.962)",
    id: "path119"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-746.58472,-1026.5127)",
    id: "path121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-810.94915,-1052.0775)",
    id: "path123"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-932.65885,-997.54723)",
    id: "path125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1035.1521,-908.69152)",
    id: "path127"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1023.7449,-869.49952)",
    id: "path129"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1044.4707,-803.54192)",
    id: "path131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1011.9666,-934.21982)",
    id: "path133"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath135"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-907.29962,-1013.2957)",
    id: "path135"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath137"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-688.41782,-904.21162)",
    id: "path137"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-698.53742,-987.54802)",
    id: "path139"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1036.7047,-758.66532)",
    id: "path141"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath143"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1006.3608,-714.55302)",
    id: "path143"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-988.4359,-668.70612)",
    id: "path145"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path147"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1448.6482,-330.44008)",
    id: "path149"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1484.553,-395.21953)",
    id: "path151"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath153"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1727.5768,-383.04658)",
    id: "path153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1805.9775,-398.72631)",
    id: "path155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath157"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1921.3009,-465.36021)",
    id: "path157"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2060.1441,-444.11111)",
    id: "path159"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath161"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2219.6161,-387.99778)",
    id: "path161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath163"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2273.2569,-402.02714)",
    id: "path163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath165"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1348.3864,-169.73383)",
    id: "path165"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath167"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1555.7218,-146.2142)",
    id: "path167"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(0,2.5000001e-5)",
    id: "path169"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1709.6265,-203.77191)",
    id: "path171"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1738.0992,-142.0892)",
    id: "path173"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1977.2043,-146.2142)",
    id: "path175"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath177"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-2076.646,-203.77191)",
    id: "path177"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath179"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1364.7126,-522.17052)",
    id: "path179"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1451.1855,-545.18511)",
    id: "path181"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1472.6205,-547.51422)",
    id: "path183"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath185"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1537.0099,-541.82971)",
    id: "path185"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1571.3976,-549.09792)",
    id: "path187"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath189"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1626.1897,-571.64592)",
    id: "path189"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath191"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1713.501,-543.32061)",
    id: "path191"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1768.0164,-545.18511)",
    id: "path193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath195"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1781.3428,-515.74062)",
    id: "path195"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath197"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1854.5863,-571.64592)",
    id: "path197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath199"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1913.6671,-546.76881)",
    id: "path199"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1181.237 H 2460.517 V 0 H 0 Z",
    transform: "translate(-1972.9338,-578.54031)",
    id: "path201"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M 2404.934,29.813 H 1282.41 v 1122.635 h 1122.524 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M 54.345,23.712 H 1188.203 V 1157.548 H 54.345 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 61.431,30.798 H 1181.116 V 1150.461 H 61.431 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m 0,0 c 0,39.063 -18.941,66.334 -50.897,66.334 -34.747,0 -50.947,-32.736 -50.947,-66.334 0,-39.055 18.957,-66.293 50.947,-66.293 C -16.167,-66.293 0,-33.557 0,0 m 23.701,0.771 c 0,-42.969 -33.163,-74.162 -74.598,-74.162 -42.248,0 -74.623,31.546 -74.623,72.636 0,42.994 33.163,74.195 74.623,74.195 42.231,0 74.598,-31.595 74.598,-72.669",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,377.38133,1282.9179)",
    clipPath: "url(#clipPath5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 0,0 c 0,39.063 -18.957,66.334 -50.922,66.334 -34.739,0 -50.914,-32.736 -50.914,-66.334 0,-39.055 18.941,-66.293 50.914,-66.293 C -16.192,-66.293 0,-33.557 0,0 m 23.676,0.771 c 0,-42.969 -33.155,-74.162 -74.598,-74.162 -42.248,0 -74.623,31.546 -74.623,72.636 0,42.994 33.171,74.195 74.623,74.195 42.239,0 74.598,-31.595 74.598,-72.669",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,984.79187,1282.9179)",
    clipPath: "url(#clipPath7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 0,0 c -8.297,11.842 -11.456,16.159 -21.706,16.159 h -11.063 v -48.165 c 0,-3.947 1.584,-5.884 5.933,-6.688 l 16.176,-3.553 v -5.154 h -63.552 v 5.154 l 14.607,3.553 c 4.325,1.173 5.909,2.741 5.909,6.688 V 79.333 c 0,3.947 -1.584,5.523 -5.909,6.688 l -14.607,3.553 v 5.163 h 61.968 c 13.04,0 22.108,-1.215 29.609,-3.948 C 32.769,84.856 41.443,70.224 41.443,56.445 41.443,39.047 28.428,24.414 6.705,19.343 v -0.788 c 4.358,-2.011 6.713,-4.76 22.117,-24.923 l 19.334,-25.638 c 2.766,-3.947 6.319,-6.294 10.669,-7.098 l 14.206,-3.143 v -5.154 H 39.08 c -3.947,0 -5.925,1.206 -9.471,5.958 z m -32.769,22.888 h 17.767 c 26.844,0 32.769,16.947 32.769,33.154 0,12.237 -5.531,23.685 -18.161,29.2 -6.705,2.773 -13.024,2.773 -21.715,2.773 h -10.66 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1136.8964,1314.4492)",
    clipPath: "url(#clipPath9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 0,0 H 5.925 V -47.385 H 0 l -3.553,14.206 c -1.199,5.154 -4.35,7.107 -9.077,7.107 h -34.361 v -52.104 c 0,-3.947 1.592,-5.884 5.925,-6.688 l 16.2,-3.562 v -5.145 h -63.56 v 5.145 l 14.608,3.562 c 4.349,1.165 5.925,2.741 5.925,6.688 v 111.33 c 0,3.948 -1.576,5.524 -5.925,6.689 l -14.608,3.562 v 5.153 H 18.941 V 12.991 H 13.016 L 6.319,34.336 c -1.584,5.507 -3.947,7.501 -8.691,7.501 h -44.619 v -61.18 h 34.361 c 4.727,0 7.484,1.945 9.077,7.107 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,765.82427,1252.8819)",
    clipPath: "url(#clipPath11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "m 0,0 v -122.352 c 0,-5.162 1.174,-6.368 6.311,-6.368 h 17.373 c 16.578,0 28.814,2.413 37.504,8.716 14.592,10.635 21.313,29.986 21.313,54.475 0,24.077 -6.721,47.737 -26.45,59.194 C 47.771,-1.584 37.102,0 20.517,0 Z m -41.452,-135.408 v 5.153 l 14.6,3.546 c 4.349,1.173 5.925,2.749 5.925,6.705 V -8.682 c 0,3.947 -1.576,5.522 -5.925,6.696 l -14.6,3.553 V 6.721 H 25.26 c 18.161,0 31.185,-2.38 41.845,-7.107 26.844,-12.244 39.089,-38.685 39.089,-64.741 0,-25.293 -9.487,-48.944 -33.566,-61.582 -11.037,-5.95 -26.441,-8.699 -46.572,-8.699 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1304.7904,1197.0996)",
    clipPath: "url(#clipPath13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M 0,0 V -5.154 H -50.134 V 0 l 12.613,3.135 c 4.768,1.215 7.903,2.757 11.055,6.303 l 43.437,54.491 -43.437,57.643 c -2.75,3.947 -6.287,5.909 -10.644,7.099 l -11.851,3.151 v 5.154 H 13.41 v -5.154 L 0,129.073 c -4.752,-0.804 -3.562,-2.766 -1.198,-5.933 L 30.775,77.347 h 0.788 L 64.34,123.14 c 2.355,3.167 3.159,4.341 -1.19,5.531 l -12.63,3.151 v 5.154 h 50.134 v -5.154 l -12.63,-3.151 c -4.735,-1.19 -7.895,-2.758 -11.062,-6.303 L 35.912,70.617 81.697,10.25 c 2.774,-3.955 6.327,-5.9 10.66,-7.115 L 104.216,0 V -5.154 H 41.837 V 0 l 13.418,2.749 c 4.744,0.796 3.947,2.339 1.576,5.564 L 22.092,57.241 H 21.304 L -13.82,8.641 C -16.192,5.49 -16.979,4.35 -12.646,3.135 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,483.19733,1370.7745)",
    clipPath: "url(#clipPath15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 0,0 c -3.923,-3.923 -9.815,-6.549 -18.03,-6.549 -7.164,0 -13.795,2.257 -18.292,6.754 -6.131,6.122 -5.852,13.951 -5.852,22.305 v 39.532 h 8.059 V 19.581 c 0,-5.375 -0.164,-10.603 3.989,-14.764 2.88,-2.872 7.303,-4.431 12.4,-4.431 4.981,0 8.978,1.723 11.481,4.218 4.62,4.62 4.325,9.651 4.325,21.813 V 62.042 H 6.024 V 28.502 C 6.024,15.765 6.532,6.533 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,283.8216,1098.9661)",
    clipPath: "url(#clipPath17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,0 -32.433,55.189 -32.236,0 h -7.402 v 67.318 h 8.264 L 1.165,11.834 0.968,67.318 H 8.379 L 8.379,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,379.20213,1106.0085)",
    clipPath: "url(#clipPath19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "m 320.85,419.051 h 8.1 v -67.318 h -8.1 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "m 0,0 h -9.273 l -23.209,67.318 h 8.437 L -4.407,7.887 15.814,67.318 h 7.837 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,505.75453,1105.9979)",
    clipPath: "url(#clipPath23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M 0,0 V 67.318 H 36.601 V 60.597 H 7.936 V 38.382 h 26.901 v -6.54 H 7.936 V 6.918 H 37.398 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,561.72693,1105.9979)",
    clipPath: "url(#clipPath25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m 0,0 -7.731,17.447 c -4.8,10.735 -6.975,11.834 -16.733,11.834 h -4.702 V 0 h -7.928 v 67.318 h 14.518 c 8.978,0 15.756,0.058 21.05,-5.243 3.372,-3.365 5.244,-7.846 5.244,-13.459 0,-4.678 -1.354,-8.568 -4.169,-11.563 -2.429,-2.585 -6.434,-4.842 -10.8,-5.31 2.371,-0.139 4.333,-1.42 5.597,-2.683 1.838,-1.839 3.167,-4.613 5.137,-9.011 L 8.428,0 Z m -7.353,57.184 c -3.857,3.865 -8.863,3.684 -14.353,3.684 h -7.46 V 35.731 h 2.675 c 6.803,0 14.124,-0.353 18.736,4.259 2.232,2.233 3.471,5.359 3.471,8.774 0,3.791 -1.477,6.836 -3.069,8.42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,689.63627,1105.9979)",
    clipPath: "url(#clipPath27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "m 604.298,419.051 h 8.1 v -67.318 h -8.1 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M 0,0 V -60.597 H -8.1 V 0 H -28.099 V 6.713 H 19.95 L 19.95,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,878.15947,1025.1979)",
    clipPath: "url(#clipPath31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M 0,0 V -26.598 H -8.001 V 0 l -21.362,40.713 h 9.257 L -3.512,9.142 12.589,40.713 h 8.781 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,956.42107,1070.5276)",
    clipPath: "url(#clipPath33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "m 0,0 c -17.431,0 -30.159,14.395 -30.159,34.623 0,20.796 12.597,35.239 30.774,35.239 17.637,0 30.07,-14.287 30.07,-34.615 C 30.685,14.411 18.219,0 0,0 m -0.025,62.985 c -13.196,0 -21.764,-11.136 -21.764,-27.935 0,-16.725 9.537,-28.116 22.191,-28.116 14.075,0 21.895,11.974 21.895,28.658 0,16.413 -9.24,27.393 -22.322,27.393",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1085.6368,1107.6989)",
    clipPath: "url(#clipPath35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "m 0,0 v -22.215 h 26.031 v -6.549 H 0 V -60.597 H -8.034 V 6.713 H 27.714 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1166.7795,1025.1979)",
    clipPath: "url(#clipPath37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "m 0,0 c 0,10.348 8.33,17.71 20.484,17.71 12.31,0 18.21,-6.36 18.809,-7.017 L 35.346,5.917 c -1.502,1.165 -6.894,5.121 -14.329,5.121 -8.592,0 -13.344,-4.489 -13.344,-10.578 0,-2.946 1.207,-5.072 3.152,-6.82 2.306,-2.068 5.679,-3.603 9.298,-5.269 4.513,-2.076 10.701,-4.415 14.845,-8.715 2.864,-2.971 5.039,-6.828 5.039,-12.138 0,-11.194 -7.771,-19.728 -21.739,-19.728 -11.908,0 -19.425,6.557 -20.131,7.222 l 3.709,5.457 c 1.913,-1.42 9.389,-5.843 16.217,-5.843 10.127,0 13.926,5.539 13.926,12.236 0,3.102 -1.419,5.605 -3.52,7.616 -3.135,3.028 -7.887,5.055 -12.441,7.131 -4.522,2.068 -8.88,4.226 -11.966,7.476 C 2.027,-8.781 0,-5.285 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,722.63667,1038.1435)",
    clipPath: "url(#clipPath39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "m 0,0 c 0,8.461 -2.856,15.281 -9.052,18.916 -3.89,2.282 -9.142,3.028 -15.617,3.028 h -47.139 v -95.179 h 51.3 c 11.825,0 18.776,-2.659 19.384,-13.262 h 1.132 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1134.9695,408.98347)",
    clipPath: "url(#clipPath41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 0,0 c 0,8.461 2.856,15.281 9.06,18.916 3.882,2.282 9.134,3.028 15.617,3.028 H 72.144 V -73.235 H 20.508 c -11.825,0 -18.776,-2.659 -19.384,-13.262 h -1.132 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1143.7539,408.98347)",
    clipPath: "url(#clipPath43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "m 0,0 v -100.613 h -72.883 l -0.829,-2.059 c -1.272,-3.135 -3.537,-6.048 -11.497,-6.048 -7.944,0 -10.226,2.913 -11.498,6.048 l -0.829,2.059 h -72.759 V 0 h -6.582 v -3.061 l -6.303,1.928 c -0.738,2.495 -3.012,4.317 -5.736,4.317 -3.299,0 -5.991,-2.684 -5.991,-5.999 0,-3.307 2.692,-5.991 5.991,-5.991 1.452,0 2.765,0.534 3.791,1.387 l 8.248,-2.527 v -8.092 l -6.196,1.108 c -0.911,2.142 -3.036,3.643 -5.515,3.643 -3.299,0 -5.982,-2.683 -5.982,-5.998 0,-3.308 2.683,-5.983 5.982,-5.983 1.707,0 3.25,0.714 4.341,1.871 l 7.37,-1.329 v -8.248 l -6.475,0.296 c -1.05,1.731 -2.938,2.921 -5.113,2.921 -3.315,0 -6.007,-2.684 -6.007,-5.999 0,-3.307 2.692,-5.991 6.007,-5.991 1.986,0 3.742,0.985 4.834,2.487 l 6.754,-0.296 v -8.961 l -6.623,-0.238 c -1.083,1.518 -2.847,2.527 -4.866,2.527 -3.299,0 -5.991,-2.691 -5.991,-5.999 0,-3.307 2.692,-5.998 5.991,-5.998 2.166,0 4.054,1.173 5.104,2.896 l 6.385,0.23 v -8.264 l -7.238,-1.239 c -1.1,1.157 -2.635,1.904 -4.35,1.904 -3.315,0 -6.007,-2.692 -6.007,-5.999 0,-3.307 2.692,-5.999 6.007,-5.999 2.446,0 4.555,1.485 5.482,3.602 l 6.106,1.051 v -8.1 l -7.911,-2.421 c -1.042,0.854 -2.347,1.395 -3.8,1.395 -3.299,0 -5.982,-2.691 -5.982,-5.999 0,-3.307 2.683,-5.999 5.982,-5.999 2.717,0 4.998,1.83 5.728,4.317 l 5.983,1.822 v -7.846 l -8.748,-3.767 c -0.936,0.624 -2.068,1.002 -3.291,1.002 -3.299,0 -5.991,-2.692 -5.991,-5.999 0,-3.308 2.692,-6 5.991,-6 2.954,0 5.392,2.143 5.892,4.949 l 6.147,2.651 v -7.156 h 75.296 c 3.044,-5.343 8.346,-8.1 16.372,-8.1 8.026,0 13.327,2.757 16.388,8.1 H 6.582 L 6.582,0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1253.0713,389.1016)",
    clipPath: "url(#clipPath45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "m 0,0 c -15.215,0 -27.55,-2.372 -27.55,-5.285 0,-2.922 12.335,-5.285 27.55,-5.285 15.215,0 27.558,2.363 27.558,5.285 C 27.558,-2.372 15.215,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1073.4177,344.3648)",
    clipPath: "url(#clipPath47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "m 0,0 -15.913,-11.177 -0.131,-1.141 3.783,-1.69 c 0.747,-0.378 0.755,-0.977 0.37,-1.338 l -9.988,-8.437 -0.952,0.082 -7.082,10.439 c -0.484,0.673 -0.304,1.346 0.55,1.494 l 4.743,0.771 v 1.199 L -36.93,7.599 h -2.027 l -12.31,-17.397 v -1.199 l 4.752,-0.771 c 0.845,-0.148 1.026,-0.821 0.542,-1.494 l -7.083,-10.439 -0.952,-0.082 -9.322,8.437 c -0.386,0.361 -0.378,0.96 0.369,1.338 l 3.783,1.69 -0.139,1.141 L -75.886,0 l -1.346,-0.533 9.733,-29.716 c 4.94,2.224 16.273,3.783 29.56,3.849 13.278,-0.066 24.62,-1.625 29.56,-3.849 l 9.725,29.716 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1124.0032,300.35147)",
    clipPath: "url(#clipPath49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "m 0,0 c -15.223,0 -27.558,-2.364 -27.558,-5.285 0,-2.922 12.335,-5.285 27.558,-5.285 15.215,0 27.55,2.363 27.55,5.285 C 27.55,-2.364 15.215,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1139.308,610.0992)",
    clipPath: "url(#clipPath51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "m 0,0 -15.904,-11.177 -0.14,-1.141 3.783,-1.699 c 0.747,-0.369 0.755,-0.968 0.37,-1.329 l -9.98,-8.437 -0.952,0.082 -7.082,10.439 c -0.484,0.673 -0.312,1.346 0.55,1.494 l 4.743,0.771 v 1.19 l -12.31,17.406 h -2.035 l -12.31,-17.406 v -1.19 l 4.752,-0.771 c 0.853,-0.148 1.026,-0.821 0.55,-1.494 l -7.082,-10.439 -0.961,-0.082 -9.322,8.437 c -0.386,0.361 -0.378,0.96 0.369,1.329 l 3.783,1.699 -0.131,1.141 L -75.878,0 l -1.346,-0.525 9.725,-29.724 c 4.94,2.224 16.282,3.775 29.56,3.84 13.286,-0.065 24.62,-1.616 29.56,-3.84 l 9.725,29.724 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1189.8837,566.08427)",
    clipPath: "url(#clipPath53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "m 0,0 c -15.215,0 -27.55,-2.372 -27.55,-5.285 0,-2.922 12.335,-5.285 27.55,-5.285 15.215,0 27.55,2.363 27.55,5.285 C 27.55,-2.372 15.215,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1205.0299,344.3648)",
    clipPath: "url(#clipPath55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "m 0,0 -15.904,-11.177 -0.14,-1.141 3.783,-1.69 c 0.747,-0.378 0.755,-0.977 0.37,-1.338 l -9.98,-8.437 -0.952,0.082 -7.082,10.439 c -0.484,0.673 -0.312,1.346 0.542,1.494 l 4.751,0.771 v 1.199 l -12.31,17.397 h -2.027 L -51.267,-9.798 v -1.199 l 4.76,-0.771 c 0.845,-0.148 1.018,-0.821 0.542,-1.494 l -7.091,-10.439 -0.952,-0.082 -9.314,8.543 c -0.394,0.362 -0.386,0.961 0.361,1.338 l 3.783,1.584 -0.139,1.141 L -75.878,0 l -1.346,-0.533 9.725,-29.716 c 4.94,2.224 16.273,3.783 29.56,3.849 13.286,-0.066 24.62,-1.625 29.56,-3.849 l 9.725,29.716 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1255.6111,300.35147)",
    clipPath: "url(#clipPath57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "m 0,0 c 0,-1.863 0.468,-2.224 1.469,-2.224 1.805,0 3.635,1.994 3.635,5.704 0,4.513 -2.289,5.769 -4.07,5.769 C 0.542,9.249 0.279,9.191 0.123,9.109 0.025,9.06 0,8.576 0,8.059 Z m 1.034,10.299 c 2.577,0 4.719,-0.501 6.122,-1.863 C 8.141,7.493 8.97,5.942 8.97,4.128 c 0,-5.219 -3.972,-7.46 -8.831,-7.46 h -5.408 v 0.813 c 1.543,0.131 1.707,0.279 1.707,2.544 v 6.918 c 0,2.265 -0.164,2.421 -1.534,2.536 v 0.82 z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1054.0797,413.59093)",
    clipPath: "url(#clipPath59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "m 0,0 c 0,-3.8 1.42,-6.574 3.48,-6.574 1.805,0 2.79,1.748 2.79,5.548 0,4.21 -1.51,6.541 -3.307,6.541 C 1.346,5.515 0,3.677 0,0 m 10.184,-0.353 c 0,-4.497 -3.069,-7.304 -7.098,-7.304 -4.243,0 -6.984,3.086 -6.984,6.943 0,3.398 2.265,7.32 7.279,7.32 3.841,0 6.803,-2.815 6.803,-6.959",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1073.6607,408.24613)",
    clipPath: "url(#clipPath61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    d: "m 0,0 v -0.82 c -1.6,-0.148 -1.682,-0.23 -1.617,-2.438 l 0.206,-7.025 c 0.057,-2.322 0.098,-2.388 1.608,-2.536 v -0.82 h -6.565 v 0.82 c 1.584,0.148 1.641,0.214 1.616,2.536 l -0.057,7.386 h -0.09 l -4.046,-10.521 h -1.124 l -3.849,9.783 h -0.041 l -0.148,-4.662 c -0.066,-1.797 -0.041,-2.798 0.041,-3.447 0.082,-0.787 0.55,-0.976 1.912,-1.075 v -0.82 h -5.187 v 0.82 c 1.01,0.082 1.404,0.288 1.535,1.075 0.107,0.649 0.238,1.757 0.337,3.661 l 0.229,4.242 c 0.14,2.643 -0.024,2.873 -1.682,3.021 V 0 h 4.94 L -8.313,-8.313 -5.104,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1111.9385,399.85133)",
    clipPath: "url(#clipPath63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "m 0,0 c 0,-2.265 0.164,-2.413 1.608,-2.544 v -0.812 h -6.786 v 0.812 C -3.734,-2.413 -3.57,-2.265 -3.57,0 v 6.926 c 0,2.265 -0.164,2.413 -1.608,2.536 v 0.821 H 1.608 V 9.462 C 0.164,9.339 0,9.191 0,6.926 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1121.0172,413.56307)",
    clipPath: "url(#clipPath65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "M 0,0 H -1.797 L -9.569,9.905 H -9.61 V 6.04 c 0,-2.199 0.082,-3.356 0.172,-4.005 0.107,-0.73 0.673,-1.009 2.052,-1.075 V 0.148 h -5.219 V 0.96 c 0.919,0.049 1.469,0.345 1.575,1.075 0.082,0.649 0.164,1.806 0.164,4.005 v 3.865 c 0,1.551 -0.041,1.83 -0.467,2.413 -0.312,0.443 -0.829,0.583 -1.584,0.648 v 0.821 h 4.628 L -1.305,5.08 h 0.049 v 2.814 c 0,2.2 -0.09,3.357 -0.164,4.006 -0.115,0.73 -0.681,1.001 -2.06,1.066 v 0.821 H 1.863 V 12.966 C 0.821,12.925 0.271,12.63 0.172,11.9 0.09,11.251 0,10.094 0,7.894 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1075.9673,451.80347)",
    clipPath: "url(#clipPath67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "m 0,0 c -1.444,3.775 -3.414,8.961 -4.177,10.931 -0.681,1.806 -1.108,1.912 -2.117,2.035 v 0.821 H 0.492 V 12.966 L -0.23,12.884 c -0.771,-0.09 -0.771,-0.279 -0.541,-1.009 0.377,-1.174 2.035,-5.31 2.814,-7.362 0.649,1.782 1.986,5.786 2.315,6.779 0.451,1.28 0.328,1.502 -0.624,1.609 l -0.632,0.065 v 0.821 h 5.08 V 12.966 C 6.992,12.819 6.697,12.712 5.876,10.808 5.753,10.513 3.192,4.284 1.617,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1087.2956,451.80347)",
    clipPath: "url(#clipPath69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    d: "m 0,0 c 0.443,-1.215 1.682,-3.545 3.734,-3.545 1.092,0 1.929,0.714 1.929,2.076 C 5.663,-0.23 4.85,0.46 3.57,1.05 L 3.258,1.198 c -1.723,0.796 -3.677,1.879 -3.677,4.136 0,2.372 1.724,4.292 5.015,4.292 0.648,0 1.321,-0.074 1.936,-0.246 C 7.008,9.249 7.345,9.175 7.616,9.085 7.706,8.264 7.854,7.238 8.084,5.81 L 7.156,5.663 C 6.697,7.049 5.966,8.543 4.3,8.543 3.233,8.543 2.47,7.722 2.47,6.713 2.47,5.663 3.291,5.055 4.637,4.448 L 5.096,4.234 c 1.937,-0.878 3.587,-1.952 3.587,-4.398 0,-2.585 -2.068,-4.473 -5.326,-4.473 -0.838,0 -1.699,0.165 -2.266,0.353 -0.623,0.214 -1.066,0.378 -1.321,0.509 -0.164,0.96 -0.435,2.093 -0.697,3.496 z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1099.9141,445.84427)",
    clipPath: "url(#clipPath71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "m 0,0 c 0,-2.265 0.164,-2.413 1.608,-2.544 v -0.812 h -6.786 v 0.812 C -3.734,-2.413 -3.57,-2.265 -3.57,0 v 6.926 c 0,2.265 -0.164,2.413 -1.608,2.536 v 0.821 H 1.608 V 9.462 C 0.164,9.339 0,9.191 0,6.926 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1063.5272,480.6988)",
    clipPath: "url(#clipPath73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m 0,0 c 0,-1.091 0.041,-1.608 0.41,-1.797 0.337,-0.181 0.821,-0.197 1.478,-0.197 0.664,0 1.575,0.057 2.01,0.615 0.337,0.394 0.689,0.96 1.034,2.077 L 5.827,0.542 C 5.704,-0.254 5.269,-2.437 5.072,-3.077 H -5.334 v 0.812 c 1.592,0.123 1.764,0.271 1.764,2.536 v 6.926 c 0,2.265 -0.172,2.413 -1.576,2.536 v 0.821 H 1.682 V 9.733 C 0.164,9.61 0,9.462 0,7.197 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1074.6083,481.06147)",
    clipPath: "url(#clipPath75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "m 0,0 c 0,-1.091 0.041,-1.608 0.419,-1.797 0.336,-0.181 0.812,-0.197 1.46,-0.197 0.673,0 1.584,0.057 2.019,0.615 0.337,0.394 0.689,0.96 1.034,2.077 L 5.827,0.542 C 5.704,-0.254 5.269,-2.437 5.08,-3.077 H -5.334 v 0.812 c 1.592,0.123 1.764,0.271 1.764,2.536 v 6.926 c 0,2.265 -0.172,2.413 -1.576,2.536 v 0.821 h 6.82 V 9.733 C 0.164,9.61 0,9.462 0,7.197 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1090.2184,481.06147)",
    clipPath: "url(#clipPath77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    d: "m 0,0 c -1.444,3.775 -3.422,8.961 -4.177,10.931 -0.698,1.806 -1.108,1.904 -2.117,2.036 v 0.82 h 6.778 v -0.82 L -0.23,12.884 c -0.779,-0.09 -0.779,-0.279 -0.55,-1.009 0.386,-1.173 2.036,-5.31 2.815,-7.361 0.64,1.781 1.994,5.785 2.323,6.778 0.443,1.272 0.32,1.502 -0.624,1.609 l -0.632,0.066 v 0.82 h 5.08 v -0.82 C 6.984,12.819 6.688,12.712 5.876,10.808 5.753,10.513 3.192,4.284 1.617,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1103.5852,485.3704)",
    clipPath: "url(#clipPath79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "m 0,0 v -0.82 c -1.592,-0.148 -1.682,-0.23 -1.617,-2.438 l 0.214,-7.025 c 0.049,-2.322 0.09,-2.388 1.608,-2.536 v -0.82 H -6.36 v 0.82 c 1.576,0.148 1.633,0.214 1.608,2.536 l -0.049,7.386 h -0.098 l -4.046,-10.521 h -1.125 l -3.84,9.783 h -0.049 l -0.14,-4.662 c -0.074,-1.797 -0.049,-2.798 0.033,-3.447 0.082,-0.787 0.55,-0.976 1.912,-1.075 v -0.82 h -5.178 v 0.82 c 1.001,0.082 1.403,0.288 1.526,1.075 0.107,0.649 0.238,1.757 0.337,3.661 l 0.229,4.242 c 0.148,2.643 -0.016,2.873 -1.674,3.021 V 0 h 4.932 L -8.313,-8.313 -5.104,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1178.7248,399.85133)",
    clipPath: "url(#clipPath81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "m 0,0 c 0,-2.265 0.164,-2.413 1.608,-2.544 v -0.812 h -6.786 v 0.812 C -3.734,-2.413 -3.57,-2.265 -3.57,0 v 6.926 c 0,2.265 -0.164,2.413 -1.608,2.536 v 0.821 H 1.608 V 9.462 C 0.164,9.339 0,9.191 0,6.926 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1187.8103,413.56307)",
    clipPath: "url(#clipPath83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M 0,0 H -1.805 L -9.569,9.905 H -9.61 V 6.04 c 0,-2.199 0.082,-3.356 0.172,-4.005 0.099,-0.73 0.657,-1.009 2.052,-1.075 V 0.148 h -5.219 V 0.96 c 0.919,0.049 1.469,0.345 1.567,1.075 0.09,0.649 0.164,1.806 0.164,4.005 v 3.865 c 0,1.551 -0.033,1.83 -0.451,2.413 -0.32,0.443 -0.845,0.583 -1.592,0.648 v 0.821 h 4.628 L -1.305,5.08 h 0.049 v 2.815 c 0,2.199 -0.09,3.356 -0.172,4.005 -0.107,0.73 -0.673,1.001 -2.052,1.066 v 0.821 H 1.863 V 12.966 C 0.821,12.925 0.271,12.63 0.164,11.9 0.09,11.251 0,10.094 0,7.895 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1208.6233,418.236)",
    clipPath: "url(#clipPath85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    d: "M 0,0 H 2.684 L 1.362,4.005 H 1.305 Z m 2.659,-4.555 0.632,0.083 c 0.779,0.106 0.829,0.32 0.55,1.074 l -0.763,2.142 h -3.431 l -0.632,-2.018 c -0.271,-0.903 -0.271,-1.108 0.69,-1.215 l 0.607,-0.066 v -0.821 h -4.883 v 0.821 c 1.067,0.148 1.379,0.23 2.076,1.994 l 4.202,10.85 1.436,0.287 1.42,-3.964 c 0.911,-2.495 1.813,-4.965 2.61,-7.107 0.672,-1.83 1.05,-1.928 2.084,-2.06 V -5.376 H 2.659 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1216.7643,410.87627)",
    clipPath: "url(#clipPath87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "m 0,0 c 0,-2.265 0.172,-2.413 1.937,-2.544 v -0.812 h -7.345 v 0.812 c 1.682,0.131 1.846,0.279 1.846,2.544 v 9.191 h -0.361 c -1.403,0 -1.969,-0.254 -2.314,-0.64 C -6.475,8.248 -6.729,7.706 -7.008,6.524 h -0.879 c 0.091,1.765 0.206,3.209 0.255,4.276 h 0.648 c 0.32,-0.476 0.525,-0.517 1.092,-0.517 H 2.47 c 0.558,0 0.657,0.123 0.993,0.517 H 4.12 C 4.128,9.922 4.243,8.133 4.341,6.59 L 3.422,6.524 C 3.102,7.78 2.872,8.33 2.569,8.691 2.208,9.06 1.51,9.191 0.509,9.191 H 0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1178.4973,447.12987)",
    clipPath: "url(#clipPath89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    d: "m 0,0 c 0,-2.265 0.164,-2.413 1.617,-2.544 v -0.812 h -6.795 v 0.812 C -3.734,-2.413 -3.57,-2.265 -3.57,0 v 6.918 c 0,2.273 -0.164,2.421 -1.608,2.544 v 0.821 H 1.617 V 9.462 C 0.164,9.339 0,9.191 0,6.918 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1193.1488,447.12987)",
    clipPath: "url(#clipPath91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "m 0,0 c 0,-3.8 1.42,-6.574 3.48,-6.574 1.805,0 2.79,1.748 2.79,5.548 0,4.21 -1.51,6.541 -3.316,6.541 C 1.346,5.515 0,3.677 0,0 m 10.176,-0.361 c 0,-4.489 -3.069,-7.296 -7.09,-7.296 -4.243,0 -6.992,3.086 -6.992,6.935 0,3.406 2.265,7.328 7.279,7.328 3.849,0 6.803,-2.815 6.803,-6.967",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1202.8403,441.81173)",
    clipPath: "url(#clipPath93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    d: "m 0,0 v -0.82 c -1.592,-0.14 -1.674,-0.23 -1.617,-2.438 l 0.214,-7.025 c 0.057,-2.322 0.098,-2.388 1.608,-2.536 v -0.812 H -6.36 v 0.812 c 1.576,0.148 1.633,0.214 1.617,2.536 l -0.058,7.394 h -0.098 l -4.046,-10.52 h -1.125 l -3.84,9.774 h -0.049 l -0.14,-4.654 c -0.066,-1.805 -0.041,-2.806 0.033,-3.455 0.09,-0.787 0.55,-0.976 1.912,-1.075 v -0.812 h -5.178 v 0.812 c 1.009,0.082 1.403,0.288 1.534,1.075 0.099,0.649 0.23,1.757 0.329,3.669 l 0.229,4.234 c 0.148,2.643 -0.016,2.881 -1.674,3.021 V 0 h 4.932 L -8.313,-8.313 -5.104,0 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1186.7608,466.9912)",
    clipPath: "url(#clipPath95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M 0,0 C 0,2.265 -0.164,2.413 -1.567,2.536 V 3.357 H 8.371 C 8.387,2.995 8.502,1.469 8.601,-0.107 L 7.69,-0.164 C 7.476,0.862 7.246,1.445 6.902,1.781 6.573,2.142 5.876,2.265 4.76,2.265 H 4.407 c -0.796,0 -0.837,0 -0.837,-0.73 v -4.054 h 1.042 c 1.814,0 1.871,0.123 2.085,1.723 H 7.616 V -5.753 H 6.697 C 6.483,-3.906 6.426,-3.775 4.612,-3.775 H 3.57 v -3.422 c 0,-1.092 0.041,-1.609 0.418,-1.797 0.337,-0.181 0.821,-0.197 1.469,-0.197 0.837,0 1.765,0.131 2.233,0.631 0.352,0.378 0.697,1.149 1.025,2.159 L 9.626,-6.549 C 9.528,-7.574 9.093,-9.717 8.904,-10.275 H -1.781 v 0.813 C -0.164,-9.339 0,-9.191 0,-6.926 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1191.084,471.46507)",
    clipPath: "url(#clipPath97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "M 0,0 H 2.684 L 1.362,4.005 H 1.297 Z m 2.659,-4.555 0.632,0.083 c 0.779,0.106 0.829,0.32 0.55,1.074 l -0.763,2.142 h -3.431 l -0.632,-2.018 c -0.271,-0.903 -0.271,-1.108 0.681,-1.223 l 0.616,-0.058 v -0.82 h -4.883 v 0.82 c 1.067,0.148 1.379,0.23 2.076,1.994 l 4.202,10.85 1.436,0.287 1.42,-3.964 c 0.911,-2.495 1.814,-4.965 2.61,-7.107 0.673,-1.83 1.05,-1.928 2.084,-2.06 v -0.82 H 2.659 Z",
    style: {
      fill: "#0e2050",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1210.1967,478.012)",
    clipPath: "url(#clipPath99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "m 0,0 c 0,-3.036 -2.454,-5.49 -5.49,-5.49 -3.028,0 -5.482,2.454 -5.482,5.49 0,3.036 2.454,5.482 5.482,5.482 C -2.454,5.482 0,3.036 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1114.0776,710.23213)",
    clipPath: "url(#clipPath101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    d: "m 0,0 c 0,-3.036 -2.454,-5.49 -5.49,-5.49 -3.028,0 -5.482,2.454 -5.482,5.49 0,3.028 2.454,5.482 5.482,5.482 C -2.454,5.482 0,3.028 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1188.2675,722.40307)",
    clipPath: "url(#clipPath103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "m 0,0 c 0,-3.036 -2.454,-5.482 -5.49,-5.482 -3.028,0 -5.482,2.446 -5.482,5.482 0,3.036 2.454,5.49 5.482,5.49 C -2.454,5.49 0,3.036 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1146.3351,193.68667)",
    clipPath: "url(#clipPath105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    d: "m 0,0 c -0.131,-3.028 -2.684,-5.384 -5.72,-5.244 -3.028,0.115 -5.375,2.683 -5.244,5.712 0.123,3.02 2.684,5.367 5.704,5.244 C -2.224,5.589 0.123,3.028 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1320.4367,262.16827)",
    clipPath: "url(#clipPath107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "m 0,0 c 2.101,-3.036 3.168,-6.278 3.16,-9.635 -0.009,-3.84 -1.289,-6.959 -8.141,-11.702 l -19.819,-14.115 -3.644,5.243 c 0,0 20.295,14.453 20.623,14.682 3.496,2.421 4.99,4.194 4.998,6.959 0,1.756 -0.64,3.669 -1.912,5.499 -1.978,2.864 -4.522,3.775 -6.779,3.783 -2.027,0 -4.226,-1.436 -8.124,-4.161 l -18.638,-12.63 -3.569,5.146 17.726,12.014 c 4.932,3.464 8.863,5.835 12.515,5.835 C -6.278,6.902 -2.396,3.447 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,953.52573,576.20827)",
    clipPath: "url(#clipPath109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    d: "M 0,0 37.701,13.212 39.786,7.501 18.219,-18.842 45.465,-8.059 47.492,-13.623 10.242,-27.935 8.149,-22.223 29.831,4.152 2.027,-5.572 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,869.10053,524.62813)",
    clipPath: "url(#clipPath111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M 0,0 39.457,5.851 40.385,-0.468 0.936,-6.319 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,861.58547,484.61307)",
    clipPath: "url(#clipPath113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    d: "m 0,0 0.148,6.623 39.375,-16.003 -0.271,-6.573 -40.434,-12.048 0.033,6.623 32.786,9.191 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,860.02627,421.1852)",
    clipPath: "url(#clipPath115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "m 0,0 c 2.339,4.251 4.005,5.859 6.475,5.851 0.919,0 2.076,-0.23 3.233,-0.87 1.502,-0.829 2.643,-2.199 3.07,-3.684 0.164,-0.575 0.238,-1.149 0.221,-1.724 -0.008,-2.371 -1.329,-4.76 -2.716,-7.246 L 9.462,-9.15 -1.773,-3.111 Z M 7.091,12.088 C 1.461,12.08 -1.157,8.847 -4.752,2.347 l -4.677,-8.387 35.132,-19.072 3.037,5.49 -14.608,7.969 0.862,1.575 c 2.445,4.449 3.299,5.113 9.568,4.588 l 11.383,-1.002 3.25,5.893 -13.106,1.116 C 23.446,0.755 21.37,0.952 19.688,0.468 19.13,0.312 18.448,-0.041 17.8,-0.5 c 0.148,0.713 0.419,1.411 0.427,2.133 0.008,1.124 -0.148,2.24 -0.493,3.25 -0.763,2.339 -2.429,4.243 -4.956,5.638 -1.888,1.034 -3.775,1.575 -5.687,1.567",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,898.5732,318.31533)",
    clipPath: "url(#clipPath117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    d: "m 0,0 5.08,3.873 24.201,-31.701 -5.072,-3.874 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,966.23827,227.03733)",
    clipPath: "url(#clipPath119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M 0,0 25.802,13.426 28.313,8.584 18.276,3.364 34.172,-27.18 28.51,-30.127 12.605,0.41 2.511,-4.842 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,995.44627,206.30307)",
    clipPath: "url(#clipPath121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    d: "m 0,0 6.729,1.879 -5.416,-26.687 4.382,-15.15 -6.081,-1.756 -4.284,15.035 -18.932,19.769 6.549,1.896 13.631,-14.198 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1081.2655,172.21667)",
    clipPath: "url(#clipPath123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M 0,0 20.254,34.361 39.31,23.143 36.544,18.432 22.937,26.458 17.332,16.947 30.143,9.405 27.435,4.801 14.624,12.351 5.457,-3.217 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1243.5451,244.92373)",
    clipPath: "url(#clipPath125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    d: "m 0,0 14.517,17.381 2.274,-6.885 -10.825,-12.367 16.069,-3.611 2.134,-6.483 -21.978,5.318 -15.609,-18.712 -2.224,6.771 11.777,13.73 -17.612,4.021 -2.142,6.541 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1380.2027,363.398)",
    clipPath: "url(#clipPath127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 0,0 39.769,3.242 1.789,-22.051 -5.441,-0.444 -1.28,15.749 -10.997,-0.903 1.198,-14.821 -5.309,-0.427 -1.215,14.813 -17.997,-1.469 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1364.9931,415.654)",
    clipPath: "url(#clipPath129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    d: "m 0,0 c -7.763,0 -16.84,4.234 -16.84,12.072 0,2.823 0.977,6.639 4.489,9.191 2.364,1.715 5.449,2.634 8.896,2.634 3.956,0 11.087,-1.116 14.829,-6.269 1.289,-1.781 1.954,-3.849 1.945,-6.057 0,-3.052 -1.247,-6.68 -4.53,-9.052 C 6.475,0.837 3.43,0 0,0 m -3.143,30.397 c -4.604,0 -8.847,-1.247 -12.187,-3.677 -6.032,-4.365 -7.123,-10.627 -7.123,-14.295 0,-13.484 12.671,-18.875 22.182,-18.875 4.579,-0.008 8.757,1.239 12.056,3.619 6.713,4.866 7.09,12.187 7.09,14.542 0,11.76 -10.824,18.686 -22.018,18.686",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1392.6275,503.59747)",
    clipPath: "url(#clipPath131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "m 0,0 c -3.578,0 -6.82,1.502 -9.044,5.014 -1.14,1.798 -1.69,3.734 -1.69,5.679 -0.025,4.514 2.831,9.142 8.059,12.466 3.463,2.2 6.86,3.274 9.905,3.266 3.849,0 6.976,-1.691 9.068,-4.981 1.231,-1.945 1.789,-4.013 1.789,-6.081 0,-4.407 -2.782,-8.716 -7.837,-11.924 C 6.697,1.19 3.135,0 0,0 m 6.212,32.498 c -4.029,0 -8.329,-1.28 -12.465,-3.906 -7.665,-4.858 -10.456,-11.826 -10.456,-16.906 0,-3.291 0.911,-6.516 2.782,-9.479 4.26,-6.72 10.644,-8.362 14.953,-8.337 4.12,0.016 8.461,1.379 12.556,3.98 4.932,3.127 10.422,8.945 10.422,16.815 0,3.266 -0.927,6.484 -2.814,9.47 -3.496,5.499 -8.962,8.363 -14.978,8.363",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1349.2888,329.36027)",
    clipPath: "url(#clipPath133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "m 0,0 c -2.88,0 -7.058,1.411 -9.388,5.671 -1.125,2.06 -1.633,4.571 -1.633,7.156 0,7.148 4.768,17.16 13.45,17.16 4.875,0 11.005,-3.636 11.005,-12.647 C 13.434,11.588 9.397,0 0,0 m 2.052,35.576 c -8.305,0 -15.544,-5.597 -18.465,-15.544 -0.649,-2.199 -1.059,-4.398 -1.059,-6.516 0,-3.98 0.665,-7.131 2.298,-10.118 3.693,-6.746 10.439,-9.044 15.584,-9.044 2.889,0 5.687,0.665 8.248,2.06 6.729,3.685 11.169,12.219 11.169,20.393 0,3.554 -0.689,6.894 -2.257,9.75 -3.241,5.883 -9.232,9.019 -15.518,9.019",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1209.7328,223.92573)",
    clipPath: "url(#clipPath135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "m 0,0 5.359,-1.518 -6.048,-21.904 -38.596,10.587 6.59,22.158 5.244,-1.478 -4.842,-15.978 10.636,-2.921 4.111,14.517 5.138,-1.46 -4.095,-14.469 12.039,-3.299 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,917.8904,369.3712)",
    clipPath: "url(#clipPath137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "m 0,0 c 5.548,6.213 11.21,5.786 11.21,5.786 l 0.969,-5.261 c 0,0 -4.366,-0.147 -7.788,-3.98 C 2.897,-5.121 2.15,-6.861 2.15,-8.436 c 0,-1.289 0.501,-2.421 1.518,-3.324 2.766,-2.462 7.477,0.271 10.439,1.461 2.273,0.935 5.499,2.248 8.732,2.248 2.413,0 4.899,-0.681 7.173,-2.716 2.65,-2.372 3.988,-5.351 3.988,-8.469 0,-3.39 -1.313,-6.41 -3.964,-9.372 -5.088,-5.695 -11.932,-6.319 -11.932,-6.319 l -1.354,5.334 c 4.029,0.936 7.082,2.487 8.928,4.563 1.461,1.633 2.175,3.455 2.175,5.055 0,1.502 -0.632,2.914 -1.863,4.013 -0.993,0.887 -2.207,1.207 -3.529,1.182 -2.568,0 -5.637,-1.469 -8.165,-2.519 -4.85,-2.011 -9.955,-3.62 -14.534,0.467 -2.331,2.085 -3.57,4.694 -3.57,7.6 0,3.069 1.215,6.335 3.808,9.232",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,931.3832,258.256)",
    clipPath: "url(#clipPath139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    d: "m 0,0 c -1.806,0 -4.858,1.034 -6.007,4.005 -0.288,0.755 -0.411,1.518 -0.411,2.298 0.025,2.183 1.059,4.448 2.118,6.836 L -3.619,14.682 7.886,9.511 6.615,6.434 C 4.464,1.559 3.069,0.008 0,0 m -23.553,23.651 15.075,-6.819 -0.738,-1.699 c -2.06,-4.645 -2.84,-5.392 -9.134,-5.425 L -29.765,9.7 -32.49,3.545 -19.327,3.586 c 2.668,0 4.744,0 6.361,0.624 0.525,0.205 1.132,0.533 1.682,0.977 -0.025,-0.337 -0.156,-0.665 -0.156,-1.01 -0.016,-1.461 0.263,-2.913 0.804,-4.185 1.814,-4.219 6.721,-6.278 10.324,-6.27 6.336,0.008 8.765,3.808 11.85,10.791 0.124,0.255 3.71,8.544 3.71,8.544 l -36.273,16.339 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1382.2729,563.43293)",
    clipPath: "url(#clipPath141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    d: "m 0,0 c -3.168,0 -6.147,1.223 -9.241,3.693 -3.143,2.511 -6.466,6.417 -6.466,11.407 0,3.455 1.879,6.762 4.776,10.381 L -8.297,28.797 14.477,10.619 12.753,8.436 C 8.518,3.127 5.63,0 0,0 m -14.214,30.036 c -4.136,-5.186 -7.271,-9.815 -7.271,-15.798 0,-5.071 2.306,-10.848 8.133,-15.502 3.865,-3.094 8.239,-4.76 12.753,-4.76 5.547,0 10.004,1.666 16.906,10.324 l 6.302,7.92 -31.169,24.89 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1341.8144,622.24933)",
    clipPath: "url(#clipPath143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 0,0 c -37.118,-13.139 -71.775,-12.228 -101.335,-5.621 0.976,13.187 6.434,27.303 14.78,29.929 65.103,20.188 112.521,80.876 112.521,152.42 0,87.983 -71.726,159.561 -159.865,159.561 -88.155,0 -159.873,-71.578 -159.873,-159.561 0,-48.952 22.872,-95.45 61.353,-125.593 -9.143,-4.021 -16.939,-10.512 -22.577,-18.604 -2.921,1.994 -5.728,4.054 -8.33,6.188 l -1.452,-1.453 c 1.732,-2.101 4.44,-4.883 7.681,-7.985 -4.735,-7.977 -7.476,-17.258 -7.476,-27.18 0,-1.551 0.099,-3.061 0.23,-4.579 -57.274,41.738 -91.307,108.096 -91.307,179.206 0,122.262 99.481,221.734 221.751,221.734 122.27,0 221.742,-99.472 221.742,-221.734 C 87.843,106.685 55.83,42.354 0,0 m -128.639,-52.333 c -30.643,0 -68.878,10.406 -95.155,25.908 -7.961,4.702 -17.456,13.434 -17.456,28.37 0,4.021 0.796,7.87 2.192,11.415 9.806,-8.116 19.942,-15.715 26.302,-19.187 1.46,-0.812 2.306,-1.198 4.013,-1.198 4.07,0 7.386,3.324 7.386,7.411 0,3.135 -1.691,5.679 -4.506,6.901 -5.433,2.38 -16.815,7.083 -29.059,13.426 5.67,7.477 14.583,12.327 24.636,12.327 4.596,0 9.019,-0.985 13.147,-2.93 l 8.395,-4.891 c 26.705,-16.307 95.394,-58.135 178.33,-35.157 -31.473,-28.403 -70.249,-42.395 -118.225,-42.395 m 26.253,-18.67 c -8.42,0 -15.33,-5.967 -15.33,-15.125 0,-8.945 7.001,-15.1 15.33,-15.1 1.272,0 2.487,0.205 3.652,0.517 -1.764,-12.679 -16.52,-26.852 -35.551,-33.22 -18.875,6.311 -33.639,20.598 -35.584,33.204 1.158,-0.296 2.364,-0.501 3.628,-0.501 9.093,0 15.33,6.36 15.33,15.1 0,8.355 -6.549,14.903 -15.002,15.092 2.577,4.711 5.055,9.717 6.877,15.1 10.48,-1.822 20.796,-2.815 30.397,-2.815 7.854,0 15.494,0.419 22.962,1.174 0.985,-4.317 2.463,-8.839 4.186,-13.508 -0.296,0.016 -0.591,0.082 -0.895,0.082 M -210.77,49.288 c 15.765,0 30.512,-8.083 39.162,-21.041 -7.575,1.921 -15.01,4.415 -22.273,7.517 l -0.017,-0.041 -0.237,0.123 c -5.072,2.396 -10.505,3.611 -16.151,3.611 -12.556,0 -23.668,-6.163 -30.537,-15.576 -2.889,1.592 -5.777,3.283 -8.609,5.039 8.502,12.285 22.651,20.368 38.662,20.368 m 62.403,-31.455 c -1.953,-1.444 -3.513,-3.185 -4.629,-5.088 -5.785,2.79 -13.048,6.418 -17.8,9.076 6.729,-1.485 15.519,-3.373 22.429,-3.988 m 48.525,3.003 c -4.587,-6.548 -7.32,-15.658 -8.124,-24.874 -14.501,3.734 -27.648,8.757 -39.113,13.984 2.175,4.219 8.42,7.214 13.18,7.214 11.694,0 23.069,1.297 34.057,3.676 m -34.057,2.733 c -9.791,0 -19.441,0.944 -28.887,2.749 -9.118,17.882 -27.796,29.38 -47.984,29.38 -4.957,0 -9.742,-0.722 -14.304,-1.978 -38.801,28.822 -61.936,74.68 -61.936,123.008 0,84.446 68.681,153.143 153.111,153.143 84.421,0 153.111,-68.697 153.111,-153.143 0,-84.453 -68.69,-153.159 -153.111,-153.159 m -76.871,-68.647 c -25.95,0 -47.041,21.164 -47.041,47.179 0,8.157 2.06,15.822 5.712,22.519 2.413,-2.192 5.006,-4.481 7.698,-6.779 -2.29,-4.842 -3.603,-10.217 -3.603,-15.896 0,-14.156 7.14,-25.851 20.64,-33.819 7.755,-4.571 16.536,-8.699 25.834,-12.294 -3.02,-0.599 -6.114,-0.91 -9.24,-0.91 M 94.598,176.728 c 0,125.799 -102.501,228.151 -228.497,228.151 -125.996,0 -228.505,-102.352 -228.505,-228.151 0,-75.475 37.258,-145.814 99.702,-188.447 6.147,-22.863 27.066,-39.769 51.932,-39.769 6.721,0 13.245,1.264 19.441,3.66 8.363,-2.765 16.996,-5.047 25.605,-6.811 -2.413,-6.935 -5.966,-13.508 -9.339,-19.187 0,0 0.073,0.016 0.188,0.041 -0.057,-0.041 -0.131,-0.074 -0.197,-0.115 l 4.768,-4.76 c 1.207,0.657 2.586,1.075 4.063,1.075 4.702,0 8.526,-3.832 8.526,-8.543 0,-4.686 -3.824,-8.518 -8.526,-8.518 -4.112,0 -7.714,2.626 -9.602,5.441 0,0 -1.108,-3.833 -1.108,-8.896 -0.033,-16.389 17.866,-35.108 42.666,-43.002 24.792,7.713 42.675,26.572 42.666,42.977 0,5.646 -1.107,8.921 -1.107,8.921 -1.904,-2.29 -4.998,-5.441 -9.66,-5.441 -4.702,0 -8.526,3.832 -8.526,8.518 0,4.711 3.824,8.543 8.526,8.543 1.65,0 3.176,-0.501 4.481,-1.305 l 4.62,4.612 c 0.115,-0.016 0.173,-0.041 0.173,-0.041 -2.61,6.246 -4.514,11.99 -5.819,17.505 41.091,5.54 75.764,22.921 103.322,51.898 l -0.025,0.033 c 57.348,43.569 90.232,109.672 90.232,181.611",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1317.9145,683.37853)",
    clipPath: "url(#clipPath145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M 1285.044,32.399 H 2402.299 V 1149.862 H 1285.044 Z M 2410.601,24.201 H 1276.743 v 1133.858 h 1133.858 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    d: "m 0,0 c -5.981,-3.093 -19.185,-6.187 -35.895,-6.187 -44.148,0 -70.968,27.644 -70.968,69.934 0,45.799 31.771,73.444 74.269,73.444 16.71,0 28.675,-3.507 33.832,-6.19 l -5.569,-20.217 c -6.602,2.887 -15.68,5.364 -27.232,5.364 -28.263,0 -48.686,-17.743 -48.686,-51.163 0,-30.533 17.948,-50.129 48.479,-50.129 10.315,0 21.043,2.062 27.645,5.157 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1931.5309,1134.3999)",
    clipPath: "url(#clipPath149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "m 0,0 c 0,-28.263 14.233,-50.75 38.577,-50.75 24.55,0 38.371,22.693 38.371,51.78 0,26.2 -12.995,50.956 -38.371,50.956 C 13.409,51.986 0,28.675 0,0 m 103.769,2.063 c 0,-46.624 -28.265,-73.236 -66.636,-73.236 -39.196,0 -63.953,29.913 -63.953,70.761 0,42.702 26.82,72.823 66.015,72.823 40.642,0 64.574,-30.739 64.574,-70.348",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1979.4039,1048.0273)",
    clipPath: "url(#clipPath151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    d: "M 0,0 C -0.824,17.948 -1.856,39.609 -1.65,58.384 H -2.269 C -6.808,41.468 -12.585,22.693 -18.772,5.159 l -20.219,-60.24 H -58.59 L -77.156,4.333 c -5.364,17.742 -10.315,36.721 -14.028,54.051 h -0.414 C -92.216,40.23 -93.04,18.154 -94.073,-0.824 l -3.094,-55.907 h -23.724 l 9.282,139.045 h 33.422 l 18.155,-55.908 c 4.951,-16.298 9.282,-32.802 12.789,-48.273 h 0.62 c 3.713,15.059 8.458,32.183 13.821,48.479 l 19.187,55.702 H 19.393 L 27.438,-56.731 H 2.683 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2303.4357,1064.2579)",
    clipPath: "url(#clipPath153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "m 0,0 c 3.095,-0.826 7.222,-1.032 12.379,-1.032 18.979,0 30.531,9.284 30.531,25.582 0,15.472 -10.726,23.723 -28.262,23.723 C 7.634,48.273 2.683,47.655 0,47.035 Z m -25.168,64.777 c 9.076,1.651 21.661,2.889 38.783,2.889 18.569,0 32.184,-3.921 41.054,-11.347 8.252,-6.807 13.615,-17.742 13.615,-30.739 0,-13.203 -4.125,-24.136 -11.965,-31.563 -10.108,-10.109 -25.992,-14.854 -43.94,-14.854 -4.745,0 -9.078,0.206 -12.379,0.826 v -52.4 h -25.168 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2407.9699,1043.3516)",
    clipPath: "url(#clipPath155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "m 0,0 v -81.075 c 0,-27.231 11.347,-39.816 28.469,-39.816 18.36,0 29.295,12.585 29.295,39.816 V 0 h 25.374 v -79.425 c 0,-42.91 -22.073,-61.889 -55.493,-61.889 -32.184,0 -53.019,17.949 -53.019,61.683 l 0,79.631 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2561.7345,954.5064)",
    clipPath: "url(#clipPath157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M 0,0 H -39.609 V 21.249 H 65.397 V 0 H 25.374 V -117.796 H 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2746.8587,982.83853)",
    clipPath: "url(#clipPath159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M 0,0 H -52.4 V -40.846 H 6.189 V -61.683 H -77.774 V 77.362 H 3.095 V 56.527 H -52.4 V 20.631 H 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2959.488,1057.6563)",
    clipPath: "url(#clipPath161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "m 0,0 h 15.06 c 17.124,0 27.85,9.076 27.85,22.899 0,15.266 -10.726,22.28 -27.23,22.28 C 7.634,45.179 2.477,44.561 0,43.94 Z m -25.168,61.477 c 9.49,1.65 23.724,2.888 38.371,2.888 20.011,0 33.626,-3.3 42.91,-11.14 C 63.747,46.829 68.078,37.133 68.078,25.374 68.078,7.426 55.907,-4.745 42.91,-9.49 v -0.618 c 9.903,-3.713 15.886,-13.41 19.393,-26.819 4.331,-17.33 8.046,-33.422 10.932,-38.785 H 47.037 c -2.064,4.125 -5.365,15.472 -9.284,32.802 -3.919,18.154 -10.521,23.929 -24.962,24.344 H 0 v -57.146 h -25.168 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,3031.0091,1038.9505)",
    clipPath: "url(#clipPath163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "m 0,0 c 8.254,-4.745 20.631,-8.872 33.628,-8.872 16.298,0 25.374,7.634 25.374,18.98 0,10.521 -7.014,16.71 -24.756,23.106 -22.899,8.252 -37.547,20.423 -37.547,40.434 0,22.693 18.981,40.023 49.1,40.023 15.06,0 26.2,-3.301 33.42,-7.016 L 73.031,86.233 c -4.951,2.682 -14.647,6.601 -27.644,6.601 -16.092,0 -23.106,-8.664 -23.106,-16.71 0,-10.728 8.046,-15.68 26.613,-22.899 24.137,-9.076 35.896,-21.249 35.896,-41.26 0,-22.281 -16.916,-41.672 -52.812,-41.672 -14.648,0 -29.914,4.125 -37.547,8.664 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1797.8485,1348.6749)",
    clipPath: "url(#clipPath165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "m 0,0 c -5.981,-3.093 -19.185,-6.187 -35.897,-6.187 -44.146,0 -70.964,27.644 -70.964,69.934 0,45.799 31.769,73.444 74.265,73.444 16.712,0 28.677,-3.507 33.834,-6.19 l -5.569,-20.217 c -6.602,2.887 -15.68,5.364 -27.233,5.364 -28.262,0 -48.685,-17.743 -48.685,-51.163 0,-30.533 17.946,-50.129 48.479,-50.129 10.315,0 21.043,2.062 27.645,5.157 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2074.2957,1380.0344)",
    clipPath: "url(#clipPath167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "m 1602.761,142.089 h -25.374 v 139.045 h 25.374 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1574.9867)",
    clipPath: "url(#clipPath169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M 0,0 H -52.401 V -40.846 H 6.189 V -61.683 H -77.775 V 77.362 H 3.095 V 56.527 H -52.401 V 20.631 l 52.401,0 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2279.502,1303.2908)",
    clipPath: "url(#clipPath171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M 0,0 V 139.045 H 28.881 L 64.777,79.425 C 74.062,63.953 82.108,47.861 88.501,32.802 h 0.414 c -1.65,18.566 -2.27,36.514 -2.27,57.764 v 48.479 h 23.519 V 0 h -26.2 L 47.655,61.065 C 38.783,76.33 29.501,93.454 22.693,109.132 l -0.62,-0.206 C 23.105,90.978 23.312,72.617 23.312,49.718 V 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2317.4656,1385.5344)",
    clipPath: "url(#clipPath173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "m 0,0 c -5.981,-3.093 -19.185,-6.187 -35.897,-6.187 -44.146,0 -70.964,27.644 -70.964,69.934 0,45.799 31.769,73.444 74.265,73.444 16.712,0 28.677,-3.507 33.834,-6.19 l -5.569,-20.217 c -6.602,2.887 -15.68,5.364 -27.232,5.364 -28.263,0 -48.686,-17.743 -48.686,-51.163 0,-30.533 17.946,-50.129 48.479,-50.129 10.315,0 21.043,2.062 27.645,5.157 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2636.2723,1380.0344)",
    clipPath: "url(#clipPath175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M 0,0 H -52.401 V -40.846 H 6.189 V -61.683 H -77.775 V 77.362 H 3.095 V 56.527 H -52.401 V 20.631 l 52.401,0 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2768.8613,1303.2908)",
    clipPath: "url(#clipPath177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "m 0,0 c 2.05,-0.374 5.032,-0.467 8.199,-0.467 17.333,0 26.742,9.691 26.742,26.649 C 35.034,40.997 26.649,50.407 9.504,50.407 5.313,50.407 2.143,50.035 0,49.568 Z m -8.104,55.532 c 4.937,0.745 10.807,1.305 17.237,1.305 11.645,0 19.938,-2.703 25.436,-7.828 5.59,-5.123 8.852,-12.391 8.852,-22.548 0,-10.25 -3.169,-18.635 -9.04,-24.413 -5.868,-5.868 -15.558,-9.037 -27.765,-9.037 -5.776,0 -10.622,0.28 -14.72,0.745 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1819.6167,878.75933)",
    clipPath: "url(#clipPath179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M 0,0 H -24.412 V -22.643 H 2.796 v -6.801 H -32.517 V 33.355 H 1.398 v -6.801 h -25.81 V 6.707 L 0,6.707 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1934.9139,848.0732)",
    clipPath: "url(#clipPath181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "m 0,0 c 1.772,-0.467 4.008,-0.653 6.709,-0.653 9.783,0 15.746,4.752 15.746,13.418 0,8.292 -5.868,12.298 -14.813,12.298 C 4.101,25.063 1.398,24.784 0,24.41 Z m -8.104,30.281 c 3.912,0.652 9.037,1.212 15.558,1.212 8.014,0 13.884,-1.865 17.611,-5.218 3.448,-2.982 5.497,-7.547 5.497,-13.139 0,-5.682 -1.677,-10.154 -4.845,-13.417 C 21.431,-4.846 14.443,-7.175 6.523,-7.175 4.101,-7.175 1.865,-7.082 0,-6.616 v -25.158 h -8.104 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,1963.4939,844.96773)",
    clipPath: "url(#clipPath183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "m 0,0 -6.151,18.076 c -1.396,4.1 -2.329,7.827 -3.26,11.461 h -0.186 c -0.932,-3.727 -1.958,-7.549 -3.168,-11.369 L -18.916,0 Z m -20.593,-6.337 -6.522,-19.752 h -8.386 l 21.338,62.8 h 9.783 l 21.431,-62.8 H 8.385 L 1.677,-6.337 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2049.3465,852.54707)",
    clipPath: "url(#clipPath185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "m 0,0 h 8.294 c 8.664,0 14.161,4.751 14.161,11.927 0,8.106 -5.868,11.645 -14.441,11.738 -3.913,0 -6.709,-0.372 -8.014,-0.743 z m -8.104,28.604 c 4.098,0.838 9.969,1.305 15.558,1.305 8.666,0 14.258,-1.584 18.171,-5.125 3.167,-2.796 4.937,-7.082 4.937,-11.926 0,-8.293 -5.218,-13.789 -11.832,-16.027 v -0.279 c 4.844,-1.677 7.733,-6.149 9.224,-12.672 2.05,-8.759 3.541,-14.815 4.844,-17.237 h -8.386 c -1.024,1.769 -2.422,7.175 -4.191,15.001 C 18.356,-9.69 15.001,-6.43 7.642,-6.151 H 0 v -27.206 h -8.104 z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2095.1967,842.85613)",
    clipPath: "url(#clipPath187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M 0,0 H -19.1 V 6.894 H 27.394 V 0 H 8.201 V -55.905 H 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2168.2529,812.79213)",
    clipPath: "url(#clipPath189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "M 0,0 C -0.467,8.759 -1.026,19.288 -0.933,27.113 H -1.212 C -3.355,19.754 -5.963,11.926 -9.133,3.26 L -20.221,-27.208 H -26.37 L -36.527,2.703 c -2.981,8.85 -5.496,16.956 -7.266,24.41 h -0.188 c -0.186,-7.825 -0.65,-18.354 -1.21,-27.766 l -1.676,-26.927 h -7.735 l 4.379,62.8 H -39.88 L -29.166,4.846 c 2.61,-7.735 4.754,-14.629 6.337,-21.152 h 0.279 c 1.584,6.337 3.82,13.231 6.616,21.152 L -4.753,35.22 H 5.59 l 3.912,-62.8 H 1.584 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2284.6679,850.5592)",
    clipPath: "url(#clipPath191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M 0,0 H -24.412 V -22.643 H 2.796 v -6.801 H -32.517 V 33.355 H 1.398 v -6.801 h -25.81 V 6.707 L 0,6.707 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2357.3552,848.0732)",
    clipPath: "url(#clipPath193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M 0,0 V 62.8 H 8.852 L 28.978,31.028 c 4.66,-7.361 8.292,-13.977 11.274,-20.406 l 0.188,0.092 c -0.746,8.388 -0.932,16.028 -0.932,25.811 V 62.8 h 7.64 V 0 H 38.949 L 19.009,31.867 C 14.629,38.854 10.436,46.029 7.268,52.831 L 6.989,52.738 C 7.454,44.817 7.642,37.27 7.642,26.835 V 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2375.1237,887.33253)",
    clipPath: "url(#clipPath195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M 0,0 H -19.1 V 6.894 H 27.394 V 0 H 8.201 V -55.905 H 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2472.7817,812.79213)",
    clipPath: "url(#clipPath197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "m 0,0 c 0,-13.417 7.268,-25.437 20.033,-25.437 12.858,0 20.126,11.832 20.126,26.087 0,12.486 -6.523,25.532 -20.033,25.532 C 6.709,26.182 0,13.789 0,0 m 48.73,1.024 c 0,-21.617 -13.136,-33.076 -29.164,-33.076 -16.584,0 -28.23,12.857 -28.23,31.864 0,19.94 12.391,32.986 29.164,32.986 17.144,0 28.23,-13.139 28.23,-31.774",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2551.5561,845.9616)",
    clipPath: "url(#clipPath199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M 0,0 H 33.822 V -6.802 H 8.104 v -20.871 h 23.761 v -6.708 H 8.104 V -62.8 H 0 Z",
    style: {
      fill: "#002147",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,2630.5784,803.5996)",
    clipPath: "url(#clipPath201)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxfordCsPos);
export default __webpack_public_path__ + "static/media/oxford-cs-pos.ffefca341027509d3e04f7325f3468cf.svg";
export { ForwardRef as ReactComponent };